import { render, staticRenderFns } from "./MobileNav.vue?vue&type=template&id=623eb64b&scoped=true"
import script from "./MobileNav.vue?vue&type=script&lang=js"
export * from "./MobileNav.vue?vue&type=script&lang=js"
import style0 from "./MobileNav.vue?vue&type=style&index=0&id=623eb64b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "623eb64b",
  null
  
)

export default component.exports